var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('deviceBorrowItem',{staticClass:"disinfect",attrs:{"loaddingClass":"disinfect","rowKeyList":_vm.rowKeyList,"keyList":_vm.keyList,"queryType":3}})}
var staticRenderFns = []

export { render, staticRenderFns }